module.exports = __webpack_public_path__ + "img/wechat-qrcode.e796db8.svg";